import { SoundNode } from './SoundNode';
export class SamplePlayer {
    audioContext;
    constructor(audioContext) {
        this.audioContext = audioContext;
        this.audioContext = audioContext;
    }
    _play = (buffer, when, gain, offset) => {
        const node = new SoundNode(this.audioContext, buffer, gain, offset);
        node.play(when);
        return node;
    };
    get now() {
        return this.audioContext.currentTime;
    }
}
//# sourceMappingURL=SamplePlayer.js.map